export enum BadgeVariant {
    NEUTRAL = 'NEUTRAL',
    NEGATIVE = 'NEGATIVE',
    POSITIVE = 'POSITIVE',
    WARNING = 'WARNING',
    INFO = 'INFO',
}
